import React, { useState } from "react";
import { QRCode } from "react-qrcode-logo";



export default function QrCode(props) {
  const [qrCodeText, setQRCodeText] = useState("");
  console.log("setQRCodeText",setQRCodeText)
  

  // generate QR code
  const generateQRCode = () => {
    setQRCodeText(props.url);
  };

  const defaultOptions = {
    ecLevel: "M",
    enableCORS: false,
    size: 150,
    quietZone: 10,
    bgColor: "#FFFFFF",
    fgColor: "#000000",
    logoImage: "",
    logoWidth: 30,
    logoHeight: 30,
    logoOpacity: 1,
    qrStyle: "squares",
  };

  const options = { ...defaultOptions, ...props.options };

 // return <><QRCode id="qrCodeEl" size={150} value={qrCodeText} /><br /></>;

  return <QRCode value={props.url} {...options} id="react-qrcode-logo" />;
}
